var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRenLogo3F(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "121px",
    height: "52px",
    viewBox: "0 0 121 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ren-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RenBridge_v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "About-2-Light",
    transform: "translate(-494.000000, -689.000000)",
    fill: "#3F3F41",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(494.000000, 686.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ren-logo",
    transform: "translate(0.000000, 3.600000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.8576,22.9248 C99.3648,24.8448 100.1328,27.5136 100.1328,30.9312 L85.92,30.9312 C86.0688,32.6928 86.544,34.056 87.36,34.9728 C88.2574859,35.9343427 89.536527,36.446311 90.8496,36.3696 C91.957606,36.4191454 93.0519642,36.1093579 93.9696,35.4864 C94.7039621,34.8560752 95.282286,34.0641657 95.6592,33.1728 L99.84,33.1728 C99.4329514,34.8897073 98.5099857,36.4408256 97.1952,37.6176 C95.424488,39.0866649 93.1780799,39.8582276 90.8784,39.7872 C88.0512,39.7872 85.8096,38.904 84.1584,37.1808 C82.3968,35.3808 81.5136,32.9184 81.5136,29.76 C81.5136,26.9328 82.32,24.5808 84.0096,22.6704 C85.6272,20.7216 87.8496,19.7904 90.696,19.7904 C93.8208,19.7664 96.2064,20.7984 97.8576,22.9248 Z M87.5376,24.3648 C86.6829288,25.3172464 86.1446115,26.5112711 85.9968,27.7824 L95.7648,27.7824 C95.4,24.696 93.744,23.1936 90.8064,23.1936 C89.6022275,23.1125064 88.4184244,23.5349207 87.5376,24.36 L87.5376,24.3648 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.48,27.5568 L120.48,39.2688 L116.2944,39.2688 L116.2944,27.9216 C116.2944,24.7968 114.8544,23.256 111.9744,23.256 C110.95841,23.2500962 109.981488,23.6470785 109.2576,24.36 C108.332003,25.2881821 107.78892,26.5302473 107.736,27.84 L107.736,39.264 L103.5504,39.264 L103.5504,20.2848 L107.736,20.2848 L107.736,22.488 C108.414627,21.6443665 109.265608,20.9553997 110.232,20.4672 C111.202184,19.9913275 112.27155,19.7527766 113.352,19.7712 C118.08,19.7664 120.48,22.3392 120.48,27.5568 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2944,39.2736 L72.7824,28.3776 C74.1745619,28.1754084 75.4943562,27.6293435 76.6224,26.7888 C78.24,25.4688 79.0848,23.5584 79.0848,21.0576 L79.0848,20.5776 C79.0848,18.0816 78.24,16.1712 76.6224,14.8464 C75.0816,13.6368 72.9504,13.0464 70.2672,13.0464 L58.56,13.0464 L58.56,39.2688 L62.88,39.2688 L62.88,28.584 L67.4736,28.584 L74.808,39.2736 L80.2944,39.2736 Z M62.88,16.7184 L69.6768,16.7184 C71.3664,16.7184 72.6528,17.088 73.5168,17.784 C74.3379222,18.5719185 74.7788565,19.6760039 74.7264,20.8128 C74.7788565,21.9495961 74.3379222,23.0536815 73.5168,23.8416 C72.6336,24.5376 71.352,24.9072 69.6768,24.9072 L62.88,24.9072 L62.88,16.7184 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "7.0224 10.8 10.8 8.6304 11.3088 9.504 25.2336 1.4736 24.216 0.888 23.1936 0.2928 22.6848 0 0 13.104 0 13.6896 6.5136 9.9216"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "7.0224 19.0512 17.9376 12.744 18.4464 13.632 32.3712 5.5968 31.3536 5.0016 30.3312 4.416 29.8224 4.128 0 21.3456 0 21.9312 6.5136 18.1632"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "7.0224 23.1744 21.504 14.8128 22.0176 15.6912 35.9376 7.6464 34.92 7.0704 33.9024 6.4752 33.3888 6.1824 0 25.4592 0 26.0544 6.5136 22.2912"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "7.0224 27.2928 25.176 16.8144 25.6896 17.6928 39.5088 9.7152 38.4912 9.12 37.4688 8.5344 36.96 8.2416 0 29.5872 0 30.1728 6.5136 26.4048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "7.0224 31.4064 28.7472 18.8688 29.256 19.7568 43.0752 11.7696 42.0576 11.1888 41.04 10.5936 40.5264 10.3008 0 33.7008 0 34.2864 6.5136 30.528"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "44.6064 12.6576 44.0976 12.36 0 37.8288 0 38.4144 6.5136 34.656 7.0224 35.5344 28.7472 22.9968 29.256 23.8752 45.3696 14.5776 45.3696 13.3968 45.3696 13.104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2.7936 40.9152 6.4464 38.808 6.9552 39.6864 28.6416 27.168 29.1504 28.056 45.3696 18.6912 45.3696 17.5104 45.3696 16.3296 45.3696 15.744 2.2944 40.6224"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "28.6416 31.296 29.1504 32.184 45.3696 22.8192 45.3696 21.6384 45.3696 20.4576 45.3696 19.872 5.8608 42.6816 6.3744 42.9744 10.08 40.8288 10.5936 41.7168"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "9.9408 45.0384 13.6512 42.888 14.16 43.776 28.6416 35.4096 29.1504 36.2976 45.3696 26.9328 45.3696 25.752 45.3696 24.5808 45.3696 23.9904 9.4224 44.736"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "13.5072 47.0976 17.2176 44.9568 17.7312 45.8352 28.6416 39.5376 29.1504 40.416 45.3696 31.0512 45.3696 29.88 45.3696 28.6992 45.3696 28.1136 12.9984 46.8048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "16.5696 48.864 17.0784 49.1568 20.7984 47.0112 21.2976 47.8992 28.6416 43.6512 29.1504 44.5392 45.3696 35.1744 45.3696 33.9936 45.3696 32.8128 45.3696 32.2272"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "20.6448 51.2256 24.3552 49.0704 24.864 49.9584 28.6416 47.7696 29.1504 48.6576 45.3696 39.3024 45.3696 38.1216 45.3696 36.9408 45.3696 36.3552 20.136 50.9328"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "28.8048 3.5328 27.7824 2.9472 27.7824 2.9472 26.7648 2.3616 26.256 2.0592 0 17.2176 0 17.8032 6.5136 14.0496 7.0224 14.9232 14.3664 10.6848 14.8896 11.5728"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenLogo3F);
export default __webpack_public_path__ + "static/media/ren-logo-3f.9048ad15f945eb679776bd7434f87400.svg";
export { ForwardRef as ReactComponent };